import { LatLngExpression } from 'leaflet';

export const positionRef: LatLngExpression = [-23, -45, 0];
